// Formateo de montos en colones costarricenses (CRC).
// Locale es-CR: separador de miles ".", separador decimal ",", símbolo "₡".
// Acepta string ("1500000.00" del server) o number, normaliza a number (no float
// math; solo display).
//
// Para cantidades de costos lecheros los céntimos no se muestran por defecto
// (los montos típicos son grandes — ₡500.000, no ₡500.000,50). Cuando sí hay
// decimales no nulos, se muestran. Ver test exhaustivo en formatMoney.test.ts.

// Formateo manual sobre céntimos enteros — no usamos Intl.NumberFormat
// porque la implementación de "es-CR" en Node varía entre versiones (a veces
// usa NBSP como separador de miles, a veces espacio normal) y eso rompe los
// tests cross-platform. La spec dice: separador de miles ".", decimal ",",
// símbolo "₡" pegado al número.

function groupThousands(intStr: string): string {
  // "1500000" → "1.500.000". Trabaja sobre el lado entero solamente.
  return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

// Devuelve solo los dígitos formateados con separadores (sin símbolo ₡).
// Usado por AmountInput, que pinta el ₡ como prefix estático separado del
// input y necesita el resto del número.
export function formatMoneyDigits(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === "") return "";
  const num = typeof value === "string" ? Number(value) : value;
  if (!Number.isFinite(num)) return "";
  if (num < 0) return "";

  const cents = Math.round(num * 100);
  const intPart = Math.floor(cents / 100);
  const fracCents = cents % 100;

  const grouped = groupThousands(String(intPart));
  if (fracCents === 0) return grouped;
  return `${grouped},${String(fracCents).padStart(2, "0")}`;
}

export function formatMoney(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === "") return "—";
  const num = typeof value === "string" ? Number(value) : value;
  if (!Number.isFinite(num)) return "—";

  // No se admiten negativos en costos. Si llega uno, es bug del caller; lo
  // marcamos con "—" para no confundir al usuario con "-₡100".
  if (num < 0) return "—";

  return `₡${formatMoneyDigits(num)}`;
}
